import { createContext, ProviderExoticComponent, ProviderProps } from 'react';

export interface IAppContext {
}

export const AppContext = createContext<IAppContext>({} as IAppContext);
export const ContextProvider: ProviderExoticComponent<ProviderProps<IAppContext>> = AppContext.Provider;
